var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "validator_data_table"
    }
  }, [_c('div', {
    staticClass: "data_table_header"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "filter_count"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.search.length === 0,
      expression: "search.length === 0"
    }]
  }, [_vm._v(" " + _vm._s(_vm._f("pluralize")(_vm.validators.length, 'result')) + " found ")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.search.length > 0,
      expression: "search.length > 0"
    }]
  }, [_vm._v("...filtering results")])]), _c('div', {
    staticClass: "filter_input_container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search,
      expression: "search"
    }],
    staticClass: "filter",
    attrs: {
      "type": "text",
      "placeholder": "Filter by NodeID"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "duration_toggle_container"
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.modeText
    },
    model: {
      value: _vm.absolute,
      callback: function callback($$v) {
        _vm.absolute = $$v;
      },
      expression: "absolute"
    }
  })], 1)]), _c('v-data-table', {
    attrs: {
      "items": _vm.validators,
      "headers": _vm.headers,
      "search": _vm.search,
      "multi-sort": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "100px"
          }
        }, [_vm._v(" " + _vm._s(item.id) + " ")])];
      }
    }, {
      key: "item.stakeAmount",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm._f("AVAX")(item.totalStakeAmount)) + " " + _vm._s(_vm.nativeSymbol) + " ")];
      }
    }, {
      key: "item.potentialReward",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(_vm._s(_vm._f("AVAX")(item.potentialReward)) + " " + _vm._s(_vm.nativeSymbol))];
      }
    }, {
      key: "item.startTime",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "text-right date no-pad-right"
        }, [_vm._v(" " + _vm._s(_vm._f("date")(item.startTime.getTime())) + " ")]), _c('div', {
          staticClass: "text-right time no-pad-right"
        }, [_vm._v(" " + _vm._s(_vm._f("time")(item.startTime.getTime())) + " ")])];
      }
    }, {
      key: "item.elapsed",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.mode === 'absolute',
            expression: "mode === 'absolute'"
          }],
          staticClass: "diagram-container"
        }, [_c('div', {
          staticClass: "diagram"
        }, [_c('div', {
          staticClass: "chartbar",
          style: {
            left: "".concat(_vm.scale(item.startTime.getTime()), "px"),
            width: "".concat(_vm.scale(item.endTime.getTime()) - _vm.scale(item.startTime.getTime()), "px")
          }
        }), _c('div', {
          staticClass: "chartbar_complete",
          style: {
            left: "".concat(_vm.scale(item.startTime.getTime()), "px"),
            width: "".concat(_vm.scale(_vm.currentTime) - _vm.scale(item.startTime.getTime()), "px")
          }
        }), _c('div', {
          staticClass: "now",
          style: {
            left: "".concat(_vm.scale(_vm.currentTime), "px")
          }
        })])]), _vm.mode === 'relative' ? _c('div', {
          staticClass: "diagram-container"
        }, [_c('div', {
          staticClass: "diagram"
        }, [_c('div', {
          staticClass: "chartbar",
          style: {
            left: "0px",
            width: "".concat(_vm.diagramWidth, "px")
          }
        }), _c('div', {
          staticClass: "chartbar_complete",
          style: {
            left: "0px",
            width: "".concat(_vm.scaleRelative((_vm.currentTime - item.startTime.getTime()) / (item.endTime.getTime() - item.startTime.getTime())), "px")
          }
        }), _c('div', {
          staticClass: "percentage_text text-right",
          style: {
            left: "71px"
          }
        }, [_vm._v(" " + _vm._s(item.elapsed) + " % ")])])]) : _vm._e()];
      }
    }, {
      key: "item.endTime",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('div', {
          staticClass: "date"
        }, [_vm._v(_vm._s(_vm._f("date")(item.endTime.getTime())))]), _c('div', {
          staticClass: "time"
        }, [_vm._v(_vm._s(_vm._f("time")(item.endTime.getTime())))])];
      }
    }, {
      key: "item.duration",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(_vm._f("duration")(item.endTime - item.startTime)) + " ")];
      }
    }, {
      key: "item.rewardOwner.addresses?.[0]",
      fn: function fn(_ref8) {
        var _item$rewardOwner$add, _item$rewardOwner$add2;

        var item = _ref8.item;
        return [_c('router-link', {
          attrs: {
            "to": "/address/".concat((_item$rewardOwner$add = item.rewardOwner.addresses) === null || _item$rewardOwner$add === void 0 ? void 0 : _item$rewardOwner$add[0])
          }
        }, [_vm._v(_vm._s((_item$rewardOwner$add2 = item.rewardOwner.addresses) === null || _item$rewardOwner$add2 === void 0 ? void 0 : _item$rewardOwner$add2[0]) + " ")])];
      }
    }, {
      key: "item.delegationFee",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c('div', [_vm._v(_vm._s(item.delegationFee) + "%")])];
      }
    }, {
      key: "item.uptime",
      fn: function fn(_ref10) {
        var _item$uptime;

        var item = _ref10.item;
        return [_c('div', [_vm._v(_vm._s((_item$uptime = item.uptime) === null || _item$uptime === void 0 ? void 0 : _item$uptime.toFixed(2)) + "%")])];
      }
    }, {
      key: "item.delegators",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: item.delegators && item.delegators.length > 0,
            expression: "item.delegators && item.delegators.length > 0"
          }]
        }, [_vm._v(" " + _vm._s(item.delegators.length) + " ")])];
      }
    }, {
      key: "expanded-item",
      fn: function fn(_ref12) {
        var headers = _ref12.headers,
            item = _ref12.item;
        return [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, _vm._l(item.delegators, function (delegator) {
          return _c('tr', {
            key: delegator.id
          }, [_c('td', {
            staticStyle: {
              "width": "24px"
            }
          }), _c('td', [_c('div', {
            staticClass: "text-truncate delegator-label",
            staticStyle: {
              "width": "100px"
            }
          }, [_vm._v(" Delegator ")])]), _c('td', [_c('div', {
            staticStyle: {
              "width": "130px"
            }
          }, [_vm._v(" " + _vm._s(_vm._f("AVAX")(delegator.totalStakeAmount)) + " " + _vm._s(_vm.nativeSymbol) + " ")])]), _c('td', {
            staticStyle: {
              "width": "80px"
            }
          }, [_c('div', {
            staticClass: "text-right date no-pad-right"
          }, [_vm._v(" " + _vm._s(_vm._f("date")(delegator.startTime.getTime())) + " ")]), _c('div', {
            staticClass: "text-right time no-pad-right"
          }, [_vm._v(" " + _vm._s(_vm._f("time")(delegator.startTime.getTime())) + " ")])]), _c('td', {
            staticStyle: {
              "width": "125px"
            }
          }, [_c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.mode === 'absolute',
              expression: "mode === 'absolute'"
            }],
            staticClass: "diagram-container"
          }, [_c('div', {
            staticClass: "diagram"
          }, [_c('div', {
            staticClass: "chartbar",
            style: {
              left: "".concat(_vm.scale(delegator.startTime.getTime()), "px"),
              width: "".concat(_vm.scale(delegator.endTime.getTime()) - _vm.scale(delegator.startTime.getTime()), "px")
            }
          }), _c('div', {
            staticClass: "chartbar_complete",
            style: {
              left: "".concat(_vm.scale(delegator.startTime.getTime()), "px"),
              width: "".concat(_vm.scale(_vm.currentTime) - _vm.scale(delegator.startTime.getTime()), "px")
            }
          }), _c('div', {
            staticClass: "now",
            style: {
              left: "".concat(_vm.scale(_vm.currentTime), "px")
            }
          })])]), _vm.mode === 'relative' ? _c('div', {
            staticClass: "diagram-container"
          }, [_c('div', {
            staticClass: "diagram"
          }, [_c('div', {
            staticClass: "chartbar",
            style: {
              left: "0px",
              width: "".concat(_vm.diagramWidth, "px")
            }
          }), _c('div', {
            staticClass: "chartbar_complete",
            style: {
              left: "0px",
              width: "".concat(_vm.scaleRelative((_vm.currentTime - delegator.startTime.getTime()) / (delegator.endTime.getTime() - delegator.startTime.getTime())), "px")
            }
          }), _c('div', {
            staticClass: "percentage_text text-right",
            style: {
              left: "71px"
            }
          }, [_vm._v(" " + _vm._s(delegator.elapsed) + " % ")])])]) : _vm._e()]), _c('td', {
            staticStyle: {
              "width": "80px"
            }
          }, [_c('div', {
            staticClass: "date"
          }, [_vm._v(" " + _vm._s(_vm._f("date")(delegator.endTime.getTime())) + " ")]), _c('div', {
            staticClass: "time"
          }, [_vm._v(" " + _vm._s(_vm._f("time")(delegator.endTime.getTime())) + " ")])]), _c('td', {
            staticStyle: {
              "width": "85px"
            }
          }, [_vm._v(" " + _vm._s(_vm._f("duration")(delegator.endTime - delegator.startTime)) + " ")]), _c('td', {
            attrs: {
              "colspan": headers.length
            }
          }, [_c('div', [_vm._v(_vm._s(delegator.address))])])]);
        }), 0)];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }